import { render } from "./CompanyCodeBulkDialog.vue?vue&type=template&id=bb96df0e&scoped=true"
import script from "./CompanyCodeBulkDialog.vue?vue&type=script&lang=js"
export * from "./CompanyCodeBulkDialog.vue?vue&type=script&lang=js"

import "./CompanyCodeBulkDialog.vue?vue&type=style&index=0&id=bb96df0e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb96df0e"]])

export default __exports__